import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, inject, Injectable, Injector } from "@angular/core";
import { ErrorNotificationService } from "./error-notification.service";

/**
 * Application-wide error boundary. Catches otherwise-unhandled runtime errors,
 * logs them for diagnostics and surfaces a single, user-friendly notification.
 *
 * HTTP errors are intentionally ignored here because they are already handled
 * by {@link httpErrorInterceptor}; this prevents duplicate notifications.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // Resolve lazily via the injector to avoid a circular dependency during
  // application bootstrap (ErrorHandler is constructed very early).
  private readonly injector = inject(Injector);

  handleError(error: unknown): void {
    console.error("[GlobalErrorHandler]", error);

    if (error instanceof HttpErrorResponse) {
      return;
    }

    this.injector
      .get(ErrorNotificationService)
      .notify("An unexpected error occurred. Please try again.");
  }
}
